import { TKV2_ORDER_ATTACHMENT_API } from '@aloft/toolkit-shared';

import { useEffect } from 'react';

import { usePutRentalCompSequenceAPI } from '../../hooks/api/toolkitComponents.ts';
import { useEdgeTrigger } from '../../hooks/useEdgeTrigger.ts';
import { rentalCompSequenceMutationComplete } from '../../redux/features/orderSlice.ts';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.ts';
import { DEFAULT_SYNC_DRIVER_DELAY_MS } from './consts.ts';

export const useRentalCompSequenceSyncDriver = (orderID: string) => {
  const dispatch = useAppDispatch();
  const { mutate: rentalCompSequenceMutate } = usePutRentalCompSequenceAPI();
  const rentalCompSequence = useAppSelector((state) => state.order.rentalCompSequence);
  const { editRevision = 0, serverRevision = 0 } =
    useAppSelector((state) => state.order.rentalCompSequenceSync) ?? {};

  const onSuccess = () => {
    dispatch(
      rentalCompSequenceMutationComplete({
        status: 'success',
        serverRevision: editRevision,
      }),
    );
  };

  const onError = () => {
    dispatch(
      rentalCompSequenceMutationComplete({
        status: 'error',
      }),
    );
  };

  const mutate = () =>
    rentalCompSequenceMutate(
      {
        pathParams: { orderID },
        body: TKV2_ORDER_ATTACHMENT_API.RENTAL_COMP_SEQUENCE.PUT.REQUEST.BODY.parse({
          sequence: rentalCompSequence,
        }),
      },
      { onSuccess, onError },
    );

  const mutationTrigger = useEdgeTrigger({
    condition: editRevision > serverRevision,
    delayMs: DEFAULT_SYNC_DRIVER_DELAY_MS,
    action: mutate,
  });

  useEffect(() => {
    mutationTrigger.restartTimer();
  }, [editRevision, mutationTrigger]);
};
